import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";

import ModalLayout from "../../layouts/modal";

// import { t } from "../../services/translation.service";

import SummaryPlan from "../summary-plan/html";
import SummaryLocation from "../summary-location/html";

export default class SummaryModal extends Subscriber {
  state = {
    summary_modal: false,
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("summary_modal").subscribe((data) => {
        this.setState({
          summary_modal: data,
        });
      })
    );
  }

  close = () => {
    Storage.clear("summary_modal");
  };

  render() {
    let content = "";
    if (this.state.summary_modal) {
      content = (
        <ModalLayout close={this.close} extras="vmo-modal-summary" type="full-mobile" type2="title-out" title={"Summary"}>
            <SummaryLocation title={"Your chosen location"} />
            <SummaryPlan showPlanDuration={true} mobileCartPopup={true}/>
        </ModalLayout>
      );
    }

    return content;
  }
}
